import domtoimage from "dom-to-image-more";
import { saveAs } from "file-saver";
import { useFormik } from "formik";
import html2pdf from "html2pdf.js";
import JSZip from "jszip";
import moment from "moment/moment";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { updateConfig } from "../../../../store/slices/Printing/printingSlice";
import {
  useGetGliListsQuery,
  useLazyGetGliListsQuery,
  useGetOrderTypeQuery,
  useSubmitGliDataMutation,
} from "../../../../store/queries/Printing";
import { updateConfig as PrintingSlice } from "../../../../store/slices/Printing/printingSlice";
import { PrintCertficate } from "./api";
import { useSelector } from "react-redux";
import {
  DEFAULT_PAPER_SIZE,
  DEFAULT_PAPER_SIZE_ID,
} from "../CertificateTypes/VisitingCardOne/paperSize";

const useGLIPrint = ({
  visitingOneFrontPrintRef,
  visitingOneBackPrintRef,
  papperFrontPrintRef,
  papperBackPrintRef,
  bigFrontPrintRef,
  vistingDuplexRef,
  foldableCardRef,
  papperDuplexRef,
}) => {
  const [selectedValId, setSelectedValId] = useState([]);
  const [gliItems, setGliItems] = useState([]);
  const slug = sessionStorage?.getItem("slug");
  const [triggerGetGliLists] = useLazyGetGliListsQuery();
  const loadGliOptions = async (search, loadedOptions, { page }) => {
    try {
      const result = await triggerGetGliLists({
        item_type: selectedValId,
        process_slug: slug,
        search,
        page: page || 1,
        page_size: 20,
      }).unwrap();

      const gliData = result?.data?.data || [];
      const usedGliIds = gliEntries
        .map((entry) => entry.gli_number?._id)
        .filter(Boolean);
      const filteredGliData = gliData.filter(
        (item) => !usedGliIds.includes(item._id),
      );

      const filteredOptions = filteredGliData || [];
      setGliItems((prev) => {
        const existingIds = new Set(prev.map((item) => item._id));
        const newItems = filteredGliData.filter(
          (item) => !existingIds.has(item._id),
        );
        return [...prev, ...newItems];
      });

      return {
        options: filteredOptions,
        hasMore: gliData.length === 20, // if full page, assume more exist
        additional: {
          page: (page || 1) + 1,
        },
      };
    } catch (error) {
      console.error("Failed to fetch GLI options:", error);
      return {
        options: [],
        hasMore: false,
        additional: {
          page: page || 1,
        },
      };
    }
  };
  // const { selectedItems, selectedId, isMultiPrint } = useSelector(
  //   (state) => state.printing
  // );

  // const { data: basicData } = useGetCertificateListsQuery({
  //   stock_receipt_id: selectedId,
  //   is_bulk: isMultiPrint,
  // });

  // const { data: gliList } = useGetGliListsQuery(
  //   {
  //     item_type: selectedValId,
  //     process_slug: slug,
  //     // search:
  //   },
  //   {
  //     skip: selectedValId.length === 0,
  //   }
  // );
  // const uniqueItemTypes = [
  //   ...new Map(
  //     gliList?.data?.data?.map((item) => [
  //       item.item_type,
  //       { name: item.item_type, id: item._id },
  //     ])
  //   ).values(),
  // ];
  const { data: ItemType } = useGetOrderTypeQuery();
  const formattedItemTypeData = ItemType?.data.map(({ _id, name }) => ({
    id: _id,
    name,
  }));
  const [submitGliData] = useSubmitGliDataMutation();
  const dispatch = useDispatch();
  const state = useSelector((state) => state.printing);
  const [isLoading, setIsLoading] = useState(false);
  const [gliEntries, setGliEntries] = useState([
    { id: 1, gli_number: null, status: [], report_id: null, _id: null },
  ]);
  const validationSchema = Yup.object({
    item_type: Yup.object().required("Select Item Type"),
    certificate_type: Yup.object().required("Select Certificate Type"),
    gli_data: Yup.array()
      .of(
        Yup.object({
          _id: Yup.string().nullable(),
          gli_number: Yup.string().required("GLI is required"),
          status: Yup.array() // Changed to array validation
            .of(Yup.number()) // Each item should be a number
            .min(1, "At least one status is required") // Must select at least one
            .required("Status is required"),
          report_id: Yup.string().required("Report Type is required"),
        }),
      )
      .min(1, "At least one GLI entry is required"),
    side: Yup.object().test(
      "conditional-validation",
      "Select Side of Certificate",
      function (value) {
        const certificateTypeId = this.parent.certificate_type?._id;
        if (certificateTypeId === 1 || certificateTypeId === 3) {
          return value !== undefined && value !== null;
        }
        return true; // No validation if certificate_type is not 1 or 3
      },
    ),
    card_size: Yup.object().test(
      "conditional-validation",
      "Select Card Size of Certificate",
      function (value) {
        const certificateTypeId = this.parent.certificate_type?._id;
        if (certificateTypeId === 1) {
          return value !== undefined && value !== null;
        }
        return true; // No validation if certificate_type is not 1
      },
    ),
  });
  const initialValues = {
    certificate_type: "",
    side: "",
    card_size: {
      name: "Normal (7.8)",
      id: 1,
    },
    paper_size: DEFAULT_PAPER_SIZE,
    remarks: "",
    certificate_format: "",
    gli_data: [{ gli_number: null, status: [], report_id: null, _id: null }],
    item_type: "", // Include this here for full structure
    gli: [],
  };
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    validate: (values) => {
      let errors = {};
      if (
        (values?.certificate_type?._id === 1 && values?.side?.id === 1) ||
        values?.certificate_type?._id === 2
      ) {
        if (!values?.certificate_format) {
          errors.certificate_format = "Select one";
        }
      }
      // if (!values?.gli || values?.gli.length === 0) {
      //   errors.gli = "Select one or more GLI(s)";
      // }
      return errors;
    },
    onSubmit: (values) => {
      // Guard against double submits while the GLI data request is in flight.
      if (isLoading) {
        return;
      }
      setIsLoading(true);
      const Ids = values?.gli_data?.map((val) => val?._id);

      const transformedGliData =
        values.gli_data?.map((statusValue) => ({
          gli_number: statusValue.gli_number,
          receipt_id: statusValue._id, // renaming _id to receipt_id
          status: statusValue.status,
        })) || [];

      const body = {
        gli_data: transformedGliData,
        search: state.search,
        page_size: state.currentPageSize,
        page: state.currentPage,
        process_slug: slug,
      };
      submitGliData(body)
        .then((res) => {
          if (res?.data?.status_code === 200) {
            dispatch(
              updateConfig((state) => {
                state.transformedGliDataOrder = transformedGliData;
                state.currentPage = 1;
                state.selectedId = Ids;
                state.showTable = true;
                state.isMultiGliPrint = false;
                state.is_multi_print = true;
                state.gliform = {
                  certificate_type: values.certificate_type,
                  side: values.side,
                  card_size: values.card_size,
                  remarks: values.remarks,
                  certificate_format: values.certificate_format,
                  gli_data: values.gli_data,
                  item_type: values.item_type,
                  gli: values.gli,
                };
                state.clear = true;
                state.multipleTableData = res.data.data;
                state.multipleTableAllData = res.data.data.data;
              }),
            );
          } else {
            console.error("Unexpected status code:", res?.status_code);
            toast.error("Failed to submit GLI data. Please try again.");
          }
          setIsLoading(false);
        })
        .catch((err) => {
          console.error("GLI data submit failed", err);
          toast.error("Something went wrong");
          setIsLoading(false);
        });
    },
  });
  const handleItemChange = (val) => {
    setSelectedValId([val?.id]);
    // const items = gliList?.data?.data?.filter(
    //   (v) => v?.item_type === val?.name
    // );
    formik.setValues({
      ...initialValues,
      item_type: val,
    });
    formik.setErrors({});
    formik.setTouched({});
    // Optionally clear GLI field if needed
    formik.setFieldValue("gli", []);
    setGliEntries([
      { id: 1, gli_number: null, status: [], report_id: null, _id: null },
    ]);
  };
  // useEffect(() => {
  //   if (gliList?.data?.data) {
  //     setGliItems(gliList?.data?.data);
  //   }
  // }, [gliList]);

  function handleImagePrints(values) {
    if (values?.certificate_type?._id === 1) {
      if (values?.side?.id === 1) {
        handleVisitingCardImage(values);
      }
    } else if (values?.certificate_type?._id === 2) {
      handleBigCardImage();
    }
  }

  function handleBigCardImage() {
    setTimeout(() => {
      const element = bigFrontPrintRef?.current;

      if (!element) {
        toast.error("No elements in the DOM");
        return;
      }

      const items = element.querySelectorAll(".item-class-big-card");

      if (items.length === 0) {
        toast.error("No elements found with the class 'item-class-big-card'.");
        return;
      }

      const images = [];
      const zip = new JSZip();

      const processImage = (item, index) => {
        // Find the element that contains "SUMMARY NO"
        const summaryNoElement = Array.from(item?.querySelectorAll("p")).find(
          (p) => p.textContent.trim() === "SUMMARY NO",
        );

        // Access the next sibling of the ":" element, which contains the value "051BDBEKI"
        const summaryNoValue =
          summaryNoElement &&
          summaryNoElement.parentElement
            .querySelectorAll("p")[2]
            .textContent.trim();

        return new Promise((resolve) => {
          domtoimage
            .toJpeg(item, {
              cacheBust: true,
              quality: 1, // Image quality (1 is highest for PNG)
              width: item.clientWidth * 4, // Quadruple the width to boost quality
              height: item.clientHeight * 4, // Quadruple the height for higher DPI
              style: {
                transform: "scale(4)", // Scale the image to 4x for higher DPI
                transformOrigin: "top left", // Ensure scaling doesn't shift the content
                width: `${item.clientWidth}px`,
                height: `${item.clientHeight}px`,
              },
              useCORS: true, // Use CORS for external images
            })
            .then((imgData) => {
              if (imgData) {
                images.push(imgData); // Store the image data in the array
                zip.file(`${summaryNoValue}.JPG`, imgData.split(",")[1], {
                  base64: true,
                });
              }
              resolve();
            })
            .catch((error) => {
              console.error(
                "Error generating image with dom-to-image-more",
                error,
              );
              resolve(); // Continue processing even if there's an error
            });
        });
      };

      const processAllImages = async () => {
        for (let i = 0; i < items.length; i++) {
          await processImage(items[i], i);
        }

        if (images.length === 0) {
          toast.error("No images generated");
          return;
        }

        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(
            content,
            `big_cards_images_${moment(Date.now()).format(
              "MM_DD_YYYY_HH_mm_ss",
            )}.zip`,
          );
          handleCloseModal();
        });
      };

      processAllImages();
    }, 1000);
  }

  function handleVisitingCardImage() {
    setTimeout(() => {
      const element = visitingOneFrontPrintRef?.current;

      if (!element) {
        toast.error("No elements in the DOM");
        return;
      }

      const items = element.querySelectorAll(".item-class");

      if (items.length === 0) {
        toast.error("No elements found with the class 'item-class'.");
        return;
      }

      const images = [];
      const zip = new JSZip();
      const processImage = (item, index) => {
        const summaryNoElement = Array.from(item?.querySelectorAll("p")).find(
          (p) => p.textContent.trim() === "SUMMARY NO",
        );

        const summaryNoValue =
          summaryNoElement &&
          summaryNoElement.parentElement
            .querySelectorAll("p")[2]
            .textContent.trim();

        return new Promise((resolve) => {
          domtoimage
            .toJpeg(item, {
              cacheBust: true,
              quality: 1, // Image quality (1 is highest for PNG)
              width: item.clientWidth * 4, // Quadruple the width to boost quality
              height: item.clientHeight * 4, // Quadruple the height for higher DPI
              style: {
                transform: "scale(4)", // Further scale the image (4x)
                transformOrigin: "top left", // Keep the content from shifting
                width: `${item.clientWidth}px`,
                height: `${item.clientHeight}px`,
              },
              useCORS: true, // Use CORS for external images
            })
            .then((imgData) => {
              if (imgData) {
                images.push(imgData); // Store the image data in the array

                zip.file(`${summaryNoValue}.JPG`, imgData.split(",")[1], {
                  base64: true,
                });
              } else {
                console.error(
                  "Image data is null or undefined for item",
                  index,
                );
              }
              resolve();
            })
            .catch((error) => {
              console.error(
                "Error generating image with dom-to-image-more",
                error,
              );
              resolve(); // Continue processing even if there’s an error
            });
        });
      };

      const processAllImages = async () => {
        for (let i = 0; i < items.length; i++) {
          await processImage(items[i], i);
        }
        if (images.length === 0) {
          toast.error("No images generated");
          return;
        }
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(
            content,
            `visiting_cards_images_${moment(Date.now()).format(
              "MM_DD_YYYY_HH_mm_ss",
            )}.zip`,
          );
          handleCloseModal();
        });
      };
      processAllImages();
    }, 1000);
  }

  function handlePDFPrints(values) {
    if (values?.certificate_type?._id === 1) {
      if (values?.side?.id === 1) {
        handleVisitingTypeOneFrontPrintClick();
      } else if (values?.side?.id === 2) {
        handleVisitingTypeOneBackPrintClick();
      } else {
        handleVisitingDuplexPrint();
      }
    }
    if (values?.certificate_type?._id === 2) {
      handleBigClick();
    }
    if (values?.certificate_type?._id === 3) {
      if (values?.side?.id === 1) {
        handlePaperFrontClick();
      } else if (values?.side?.id === 2) {
        handlePaperBackClick();
      } else {
        handlePaperDuplexPrint();
      }
    }
    if (values?.certificate_type?._id === 4) {
      handleFoldableCardPrint();
    }
    const timeOutId = setTimeout(() => {
      dispatch(
        updateConfig((state) => {
          state.printingData = [];
          state.printUI = false;
        }),
      );
      clearTimeout(timeOutId);
    }, 1500);
  }

  const handleVisitingTypeOneFrontPrintClick = () => {
    const element = visitingOneFrontPrintRef?.current;
    html2pdf(element, {
      margin: [0, 9, 0, 9],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}visiting card certificate_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        width: 720,
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 4,
        scrollY: 0,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: false,
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();
        window.open(pdfObj.output("bloburl"), "F");
      });
  };

  const handleVisitingTypeOneBackPrintClick = () => {
    const element = visitingOneBackPrintRef?.current;
    html2pdf(element, {
      margin: [0, 9, 0, 9],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}visiting card certificate_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        width: 720,
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 7,
        scrollY: 0,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: false,
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();
        window.open(pdfObj.output("bloburl"), "F");
      });
  };

  const handlePaperFrontClick = () => {
    const element = papperFrontPrintRef?.current;
    html2pdf(element, {
      margin: [0, 5, 0, 5],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}paper certificate front_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 4,
        scrollY: 0,
      },
      // pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();

        window.open(pdfObj.output("bloburl"), "F");
      });
  };

  const handlePaperBackClick = () => {
    const element = papperBackPrintRef?.current;
    html2pdf(element, {
      margin: [5, 5, 5, 5],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}paper certificate back_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 4,
        scrollY: 0,
      },
      pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();

        window.open(pdfObj.output("bloburl"), "F");
      });
  };

  const handleBigClick = () => {
    const element = bigFrontPrintRef?.current;
    html2pdf(element, {
      margin: [5, 5, 5, 5],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}big card certificate front_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 4,
        scrollY: 0,
      },
      pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
      jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();
        window.open(pdfObj.output("bloburl"), "F");
      });
  };

  const handleVisitingDuplexPrint = () => {
    const element = vistingDuplexRef?.current;
    html2pdf(element, {
      margin: [0, 9, 0, 9],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}visiting card duplex_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        width: 720,
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 4,
        scrollY: 0,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      // pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();

        window.open(pdfObj.output("bloburl"), "F");
      });
  };

  const handlePaperDuplexPrint = () => {
    const element = papperDuplexRef?.current;
    html2pdf(element, {
      margin: [0, 5, 0, 5],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}paper certificate duplex_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 4,
        scrollY: 0,
      },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();

        window.open(pdfObj.output("bloburl"), "F");
      });
  };

  const handleFoldableCardPrint = () => {
    const element = foldableCardRef?.current;
    html2pdf(element, {
      margin: [12, 5, 0, 5],
      filename: `${state?.is_multi_print ? "" : state?.printingData?.[0]?.gli_number ? state.printingData[0].gli_number + "_" : ""}foldable_card_${moment(Date.now()).format("DD_MM_YYYY")}_${moment(Date.now()).format("HH_mm_ss")}.pdf`,
      image: { type: "jpeg", quality: 1 },
      html2canvas: {
        dpi: 100,
        letterRendering: true,
        useCORS: true,
        logging: true,
        scale: 4,
        scrollY: 0,
      },
      pagebreak: { avoid: "", mode: ["avoid-all", "css", "legacy"] },
      jsPDF: { unit: "mm", format: "a5", orientation: "landscape" },
      DisablePdfCompression: true,
    })
      .from("element-to-print")
      .outputPdf() // add this to replace implicite .save() method, which triggers file download
      .get("pdf")
      .then(function (pdfObj) {
        pdfObj.autoPrint();
        handleCloseModal();

        window.open(pdfObj.output("bloburl"), "F");
      });
  };
  const handleCloseModal = () => {
    dispatch(
      updateConfig((state) => {
        state.isMultiGliPrint = false;
        // Reset paper size so a chosen A3/A5 never carries into other print paths.
        state.paper_size = DEFAULT_PAPER_SIZE_ID;
      }),
    );
    setIsLoading(false);
  };

  const getFieldError = (fieldName) => {
    if (formik.touched[fieldName] && formik.errors[fieldName]) {
      return formik.errors[fieldName];
    }
    return "";
  };

  const setCardSize = (value) => {
    formik?.setFieldValue("card_size", value || null);
    dispatch(
      updateConfig((state) => {
        state.card_size = value?.id;
      }),
    );
  };

  const setPaperSize = (value) => {
    formik?.setFieldValue("paper_size", value || null);
    dispatch(
      updateConfig((state) => {
        state.paper_size = value?.id ?? DEFAULT_PAPER_SIZE_ID;
      }),
    );
  };

  // let reportListData = basicData?.data?.report_list?.filter(
  //   (item) => item?.certificate_type === formik?.values?.certificate_type?._id
  // );
  return {
    formik,
    // basicData,
    isLoading,
    // reportListData,
    handleCloseModal,
    getFieldError,
    setCardSize,
    setPaperSize,
    setIsLoading,
    gliItems,
    // uniqueItemTypes,
    uniqueItemTypes: formattedItemTypeData ?? [],
    handleItemChange,
    gliEntries,
    setGliEntries,
    loadGliOptions,
    selectedValId,
  };
};

export default useGLIPrint;
